import { Directive, ElementRef } from '@angular/core';

@Directive({ selector: '[appScrollable]', standalone: false})
export class ScrollableDirective {
	constructor (private _el: ElementRef) { }
	set scrollTop (value: number) { this._el.nativeElement.scrollTop = value; }
}
